import { forwardRef } from "react";
import { cva } from "class-variance-authority";
import { initials } from "../../../utils/helpers/string";
import { getUploadUrl } from "../../../utils/helpers/upload";
import { cn } from "../../../lib/utils";
import { AvatarFallback, AvatarImage, Avatar as BaseAvatar } from "../../ui/avatar";
import type { AvatarProps } from "./types";

export const avatarVariants = cva("", {
    variants: {
        size: {
            xs: "tw-h-6 tw-w-6 tw-text-[10px]",
            sm: "tw-h-8 tw-w-8 tw-text-xs",
            default: "tw-h-10 tw-w-10 tw-text-sm",
            lg: "tw-h-12 tw-w-12 tw-text-base",
        },
    },
    defaultVariants: {
        size: "default",
    },
});

const Avatar = forwardRef<HTMLSpanElement, AvatarProps>(
    ({ user, size, className, textStyles, ...props }, ref) => (
        <BaseAvatar ref={ref} className={cn(avatarVariants({ size }), className)} {...props}>
            <AvatarImage
                src={getUploadUrl(user?.image)}
                alt="user avatar"
            />
            <AvatarFallback className={textStyles}>{initials(user)}</AvatarFallback>
        </BaseAvatar>
    )
);
Avatar.displayName = "Avatar";

export default Avatar;
